import { render, staticRenderFns } from "./AffiliationGroup.vue?vue&type=template&id=455effac&"
import script from "./AffiliationGroup.vue?vue&type=script&lang=js&"
export * from "./AffiliationGroup.vue?vue&type=script&lang=js&"
import style0 from "./AffiliationGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455effac')) {
      api.createRecord('455effac', component.options)
    } else {
      api.reload('455effac', component.options)
    }
    module.hot.accept("./AffiliationGroup.vue?vue&type=template&id=455effac&", function () {
      api.rerender('455effac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/components/AffiliationGroup.vue"
export default component.exports